import logo from 'assets/images/ktech-icon.png';

const LogoIcon = () => {
  return <img src={logo} alt="Ktech" width="50" />;
};

export default LogoIcon;
